/** Review controls and composer words every action shares. Words that name a record come from the server's labels. */
export const ASSISTANT_ACTION_COPY = {
  // The approval turn is the person's own word, never a manufactured sentence about the record.
  approveOneTurn: "Approve",
  approveManyTurn: "Approve",
  // One word for not saving, on the control and in the person's recorded turn.
  dismiss: "Don't save",
  dismissTurn: "Don't save",
  resume: "Resume saving",
  openReview: "Open to save",
  openReviewSaved: "Open",
  seeAll: "See all",
  openInPane: "Open beside the conversation",
  replacedBelow: "Replaced by the update below",
  andMore: (count: number) => `and ${count} more`,
  leftOut: (count: number) => `${count} left out`,
  opensFullScreen: "Opens full screen",
  batchRuleIndependent: "Each saves on its own",
  composerHint: "Ask a question or tell me what to change.",
  inactiveConversation: "This conversation has ended. To change these, start a new conversation.",
  savedBy: (name: string, day: string) => `Saved by ${name}, ${day}`,
  decisionsNeeded: (count: number) => `${count} decision${count === 1 ? "" : "s"} needed`,
  cannotSave: (count: number) => `${count} can't be saved`,
  notSaved: "Not saved",
  savingStopped: "Saving stopped",
  dismissed: "Nothing was changed.",
  expired: "This wasn't saved in time, so nothing changed. Ask me again when you're ready.",
  interrupted: (applied: number, total: number) => `Saving stopped at ${applied} of ${total}. Resume to finish.`,
  failed: "Nothing was saved. Ask me to try again.",
  chosenRowTurn: (label: string, subject: string) => `Use ${label} for ${subject}`,
  /** The person's recorded answers: a choice's own reply text when it sets one, else "Use <label> for <subject>". */
  chosenRowsTurn: (pairs: readonly { subject: string; label: string; reply?: string }[]) => {
    const [only] = pairs;
    if (pairs.some(pair => pair.reply)) {
      return pairs.map(pair => pair.reply ?? `Use ${pair.label} for ${pair.subject}`).join(" and ");
    }
    return pairs.length === 1 && only
      ? `Use ${only.label} for ${only.subject}`
      : `Use ${pairs.map(pair => `${pair.label} for ${pair.subject}`).join(" and ")}`;
  },
  changePlaceholder: "Tell me what to change, for example: make it 82 cents",
  correctionPlaceholder: "Tell me the correction, for example: it should have been 82 cents",
  correctionPlaceholderFor: (subject: string) => `Tell me the correction for ${subject}, for example: it should have been 82 cents`,
};

export const ASSISTANT_ACTION_CUSTOMER_STRINGS = [
  ASSISTANT_ACTION_COPY.approveOneTurn,
  ASSISTANT_ACTION_COPY.approveManyTurn,
  ASSISTANT_ACTION_COPY.dismiss,
  ASSISTANT_ACTION_COPY.dismissTurn,
  ASSISTANT_ACTION_COPY.resume,
  ASSISTANT_ACTION_COPY.openReview,
  ASSISTANT_ACTION_COPY.openReviewSaved,
  ASSISTANT_ACTION_COPY.opensFullScreen,
  ASSISTANT_ACTION_COPY.batchRuleIndependent,
  ASSISTANT_ACTION_COPY.composerHint,
  ASSISTANT_ACTION_COPY.seeAll,
  ASSISTANT_ACTION_COPY.openInPane,
  ASSISTANT_ACTION_COPY.replacedBelow,
  ASSISTANT_ACTION_COPY.andMore(6),
  ASSISTANT_ACTION_COPY.leftOut(1),
  ASSISTANT_ACTION_COPY.savedBy("Jane", "Oct 27"),
  ASSISTANT_ACTION_COPY.decisionsNeeded(2),
  ASSISTANT_ACTION_COPY.cannotSave(2),
  ASSISTANT_ACTION_COPY.notSaved,
  ASSISTANT_ACTION_COPY.savingStopped,
  ASSISTANT_ACTION_COPY.dismissed,
  ASSISTANT_ACTION_COPY.expired,
  ASSISTANT_ACTION_COPY.interrupted(3, 9),
  ASSISTANT_ACTION_COPY.failed,
  ASSISTANT_ACTION_COPY.inactiveConversation,
  ASSISTANT_ACTION_COPY.chosenRowTurn("DLVD Houston", "TEG"),
  ASSISTANT_ACTION_COPY.chosenRowsTurn([
    { subject: "TEG", label: "DLVD Houston" },
    { subject: "MEG", label: "DLVD Cresson" },
  ]),
  ASSISTANT_ACTION_COPY.changePlaceholder,
  ASSISTANT_ACTION_COPY.correctionPlaceholder,
  ASSISTANT_ACTION_COPY.correctionPlaceholderFor("Supplier · Product · General"),
];
